import { useEffect, useState, Fragment } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessDesignerItem from "./ProcessDesignerItem";
import ProcessDesignerDetail from "./ProcessDesignerDetail";
import ProcessDesignerSchemaAdd from "./ProcessDesignerSchemaAdd";
import ProcessDesignerSchemaModal from "./ProcessDesignerSchemaModal";
import ProcessDesignerFlowchart from "./ProcessDesignerFlowchart";
import { FindOpenPosition } from "../../tools/DesignerHelper";

import { getLabel } from "../../tools/Dictionary";

/*
Used by ProcessDesigner
*/

const ProcessDesignerSchema = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Process = props.Process;
  const Step = props.Step;
  const StepTemplate = props.StepTemplate;
  const OnUpdateStep = props.OnUpdateStep;
  const OnConfirmComponent = props.OnConfirmComponent;
  const OnDeleteComponent = props.OnDeleteComponent;
  const OnMoveComponent = props.OnMoveComponent;
  const OnClickCondition = props.OnClickCondition;
  const Component = props.Component;
  const ComponentAction = props.ComponentAction;
  const OnDeleteStep = props.OnDeleteStep;
  const DisplayStep = props.DisplayStep;
  const OnUpdateDisplay = props.OnUpdateDisplay;
  const Flowchart = props.Flowchart;
  const OnClickSelectMultiple = props.OnClickSelectMultiple;
  const CopyMode = props.CopyMode;
  const CopyData = props.CopyData;
  const OnClickSelectCopy = props.OnClickSelectCopy;
  const TempId = props.TempId;
  const SetTempId = props.SetTempId;
  const NewCounter = props.NewCounter;
  const OnRightClickContextStep = props.OnRightClickContextStep;
  const OnRightClickContextCondition = props.OnRightClickContextCondition;
  const AddStep = props.AddStep;
  const ParentContainer = props.ParentContainer;
  const AddCondition = props.AddCondition;
  const CurrentGroup = props.CurrentGroup;
  const Group = props.Group;
  const OnUpdateGroup = props.OnUpdateGroup;
  const OnOpenGroup = props.OnOpenGroup;
  const OnClickExternalCopy = props.OnClickExternalCopy;

  //State
  const [loading] = useState(false);
  //const [tempId, setTempId] = useState(-1);
  const [stepPosition, setStepPosition] = useState(undefined);
  const [addModal, setAddModal] = useState({
    display: false,
    parentId: 0,
    parentPath: []
  });
  const [modal, setModal] = useState({
    display: false,
    template: undefined,
    step: undefined
  })
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useEffect(() => {

    

  }, [Step]);


  useEffect(() => {

    setAddModal(AddStep);

  }, [AddStep]);

  const onClickDetail = (_id) => {


    if (!CopyMode)
      OnUpdateDisplay(_id);


  };

  const onClickAdd = (_parentId, _groupId = undefined) => {


    setAddModal({
      display: true,
      parentId: _parentId,
      groupId: _groupId
    });
  };

  const onClickAddFromTemplate = (_stepTemplate) => {


    //Generate a title for the component
    let incTitle = 1; //Incremental number to complet name
    let title = ""; // hold tentative name
    let titleExist = true; // Stay true if name already exists

    //Loop until name doesn't exists
    while (titleExist)
    {

      //Try a name
      let tempTitle = _stepTemplate.defaultTitle + "_" + incTitle.toString();


      //Check if it exists
      titleExist = Step.some(s =>
      {
        //If exists return true
        if (s.title == tempTitle)
          return true;
        //Doesn't exists
        return false;

      });

      title = tempTitle;

      incTitle++;

    }

    let currentTempId = TempId;

    let position = {};

    let currentParent;

    if (addModal.parentId){
      

      currentParent = Step.find(s => s._id == addModal.parentId)


      if (currentParent){

        position = FindOpenPosition(currentParent.position.x + 300, currentParent.position.y,
          Step.filter(st => st.parentGroup == CurrentGroup[CurrentGroup.length - 1]._id),
          Group.filter(gr => gr.parentGroup == CurrentGroup[CurrentGroup.length - 1]._id),
          CurrentGroup[CurrentGroup.length - 1].entry || []
        );


        // position.x = currentParent.position.x + 150;
        // position.y = currentParent.position.y + 150;
        // console.log(CurrentGroup)




      }else {

        position = {
          x: addModal.position ? addModal.position.x : 0,
          y: addModal.position ? addModal.position.y : 0
        };

      }

    }else {

      position = {
        x: addModal.position ? addModal.position.x : 0,
        y: addModal.position ? addModal.position.y : 0
      };


    }



    let toAddStep = {
      _id: currentTempId,
      process: Process._id,
      title: title,
      navigationButton: _stepTemplate.navigationButton,
      component: _stepTemplate.component.map(c => {

        currentTempId--;

        return {
          ...c,
          _id: currentTempId
        }
      }),
      //path: addModal.parentId ? [...addModal.parentPath, addModal.parentId] : [],
      condition: [],
      position,
      isFirst: Step.length > 0 ? false : true
    }


    // if (currentParent){

    //   toAddStep.condition.push({
    //     processStep: _parentId,
    //     data: [],
    //     order: 10
    //   })

    // }
    


    if (!_stepTemplate.prefill){

      onUpdateStep(toAddStep, currentParent ? currentParent._id : undefined);

    }else{


      setModal({
        display: true,
        template: _stepTemplate,
        step: toAddStep,
        parent: currentParent ? currentParent._id : undefined,
        onConfirm: onUpdateStep,
        checkTitleExists: checkIfTitleExists
      });

    }

    incrementTempId(Math.abs(currentTempId - TempId - 1));
      
    

  };

  const checkIfTitleExists = (_title) => {

    //Check if it exists
    let titleExist = Step.some(s =>
    {
      //If exists return true
      if (s.title == _title)
        return true;
      //Doesn't exists
      return false;

    });   


    return titleExist;

  };

  const onClickPrevious = (_id) => {


    OnUpdateDisplay(_id);
    // setDisplay({
    //   detail: _id ? true : false,
    //   id: _id
    // });

  };

  const onClickHome = () => {

    setStepPosition({x: 100, y: 100});

    OnUpdateDisplay(undefined);


  };

  const incrementTempId = (_amount = 1) => {

    SetTempId(TempId => TempId - _amount);
  };

  const onUpdateStep = (_step, _parentStep) => {

    OnUpdateStep(_step, _parentStep);

    setAddModal({
      display: false
    });

  }




  return (
    <Fragment>
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      {DisplayStep.detail ? (
        <Fragment>
          <ProcessDesignerDetail
            IsDesktop={IsDesktop}
            Access={Access}
            ReadOnly={ReadOnly}
            Step={Step.find(s => s._id == DisplayStep.id)}
            Component={Component}
            ComponentAction={ComponentAction}
            OnClickHome={onClickHome}
            OnClickPrevious={onClickPrevious}
            OnUpdateStep={OnUpdateStep}
            TempId={TempId}
            IncrementTempId={incrementTempId}
            OnConfirm={OnConfirmComponent}
            OnDeleteComponent={OnDeleteComponent}
            OnMoveComponent={OnMoveComponent}
            OnDeleteStep={OnDeleteStep}
          />
        </Fragment>
      ):(
        <div className="processdesigner_schema_cont" >
          {addModal.display && 
            <ProcessDesignerSchemaAdd
              StepTemplate={StepTemplate}
              Step={Step}
              ParentId={addModal.parentId}
              ParentPath={addModal.parentPath}
              Position={addModal.position}
              GroupId={addModal.groupId}
              OnCloseModal={() => setAddModal({display: false, parentId: 0, parentPath: []})}
              OnClickAddFromTemplate={onClickAddFromTemplate}
              OnClickSelectMultiple={OnClickSelectMultiple}
              OnClickExternalCopy={OnClickExternalCopy}
            />
          }
          {modal.display &&
            <ProcessDesignerSchemaModal
              Access={Access}
              Step={modal.step}
              Parent={modal.parent}
              Template={modal.template}
              onConfirm={modal.onConfirm}
              checkTitleExists={modal.checkTitleExists}
              OnCloseModal={() => setModal({ display: false, prefill: undefined, step: undefined })}
            />
          }
          {Flowchart ? (
            <ProcessDesignerFlowchart
              ReadOnly={!Access.canWrite || ReadOnly}
              Step={Step}
              Data={Step[0] || undefined}
              OnClickDetail={onClickDetail}
              OnClickAdd={onClickAdd}
              OnClickCondition={OnClickCondition}
              OnUpdateStep={onUpdateStep}
              StepPosition={stepPosition}
              CopyMode={CopyMode}
              CopyData={CopyData}
              OnClickSelectCopy={OnClickSelectCopy}
              NewCounter={NewCounter}
              OnRightClickContextStep={OnRightClickContextStep}
              OnRightClickContextCondition={OnRightClickContextCondition}
              ParentContainer={ParentContainer}
              AddCondition={AddCondition}
              Group={Group}
              OnUpdateGroup={OnUpdateGroup}
              CurrentGroup={CurrentGroup}
              OnOpenGroup={OnOpenGroup}
            />
          ):(
            <div className="processdesigner_item_group_cont" >
              <ProcessDesignerItem
                ReadOnly={!Access.canWrite || ReadOnly}
                Step={Step}
                Data={Step[0] || undefined}
                OnClickDetail={onClickDetail}
                OnClickAdd={onClickAdd}
                OnClickCondition={OnClickCondition}
              />
            </div>
          )}
        </div>
      )}

    </Fragment>
  );

};

export default ProcessDesignerSchema